import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
// modules
import core from './modules/core'
import inputAndOutputAdjust from './modules/inputAndOutputAdjust'
import third from './modules/third'
import product from './modules/product'
import branch from './modules/branch'
import adminTable from './modules/adminTable'

import getters from './getters'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
	state: {
		response: { type: null },
	},
	mutations: {
		SET_RESPONSE: (state, connect) => {
		  state.response = connect
		},
	},
	actions: {
		showErrors({state, commit}, payload){
			for (const key in payload) {
				if (Object.hasOwnProperty.call(payload, key)) {
					payload[key].forEach(element => {
						commit('SET_RESPONSE', {type: 'error', msg: element})
					})
				}
			}
		}
	},
  modules: {
    core,
		inputAndOutputAdjust,
		third,
		product,
		branch,
		adminTable,
  },
	getters,
	plugins: [createPersistedState({ paths: ['layout'] })],
	strict: debug
})
